import { useEffect, useState } from "react";

interface UseResponsiveBreakpointsConfig {
  values: Record<number, any>;
  default: any;
}

function getValueForWidth(
  width: number,
  config: UseResponsiveBreakpointsConfig
) {
  let selectedValue = config.default;
  if (config.values) {
    const sortedBreakpoints = Object.keys(config.values)
      .map((k) => parseInt(k, 10))
      .sort((a, b) => b - a);

    for (const breakpoint of sortedBreakpoints) {
      if (width >= breakpoint) {
        selectedValue = config.values[breakpoint];
        break;
      }
    }
  }
  return selectedValue;
}

function useResponsiveBreakpoints(config: UseResponsiveBreakpointsConfig) {
  const [value, setValue] = useState(() => {
    if (typeof window !== "undefined") {
      return getValueForWidth(window.innerWidth, config);
    }
    return config.default;
  });

  useEffect(() => {
    function handleResize() {
      setValue(getValueForWidth(window.innerWidth, config));
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [config]);

  return value;
}

export default useResponsiveBreakpoints;
